import {Api, apiFetch} from "../_helpers/api";
import {createQueryParameters, to_url} from "../_helpers/utils";
import * as ts from "typescript/lib/tsserverlibrary";
import Err = ts.server.Msg.Err;
import Booth, {boothToApiDict} from "../_data/models/Booth";

const BoothRepository = {
    listByShop: (shopId: number, cursor: number = null, page: number = null, perPage: number = 5) => {
        const query = createQueryParameters({cursor: cursor, page: page, per_page: perPage, is_cursor: true});
        return apiFetch(to_url(Api.apiBaseUrl, 'salons', shopId, "booths") + query)
            .then(response => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    return {
                        error: true,
                        response: response
                    };
                }
            });
    },

    // TODO: booth here is form data not Booth model
    saveBooth: (booth: Booth) => {
        const isNew = !(booth.id && booth.id != 0);
        let url = isNew
            ? to_url(Api.apiBaseUrl, 'booths')
            : to_url(Api.apiBaseUrl, 'booths', booth.id);

        return fetch(url, {
            credentials: "same-origin",
            method: isNew ? "POST" : "PUT",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Cache': 'no-cache'
            },
            body:JSON.stringify({
                booth: boothToApiDict(booth)
            })
        }).then(response => {
            return response.json();
        });
    }
};

export default BoothRepository;


// WEBPACK FOOTER //
// ./app/client/_repositories/boothRepository.ts